<!--
 * @Author: your name
 * @Date: 2020-09-14 10:02:55
 * @LastEditTime: 2020-09-21 09:02:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi-wap\src\App.vue
-->
<template>
<div id="app">
    <navigator />
    <router-view />
    <foot />
</div>
</template>

<script>
import navigator from "./components/navigator";
import foot from "./components/foot";
export default {
    components: {
        navigator,
        foot,
    },
};
</script>

<style lang="less">
//@font-face {
//    font-family: Source Han Sans CN;
//    src: url("../src/assets/font/GBK.TTF");
//}

//@font-face {
//    font-family: Source Han Sans CN;
//    src: url("../src/assets/font/PingFang Medium.ttf");
//}

html,
body {
    margin: 0;
    padding: 0;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
ul {
    margin: 0;
    list-style: none;
}

.child-title {
    font-size: 0.36rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    text-align: center;
}

.child-sub-title {
    font-size: 0.3rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-bottom: .56rem;
}

.rich {
    font-size: .24rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    overflow: hidden;

    img {
        max-width: 100%;
    }
}

.el-pagination {
    text-align: center;
}
</style>
